import { useRecoilState, useSetRecoilState } from 'recoil';

import {
  cashDisbursedID,
  equipmentSelectedToEdit,
  incidentSelectedToEdit,
  locationSelectedToEdit,
  personSelectedToEdit,
  truckDriversToEdit,
  truckServiceToEdit,
} from '../recoil/dataToEdit';
import { isClientDocumentsFilterModalOpenAtom } from '../recoil/modalClientDocuments';
import { isClientsFilterModalOpenAtom } from '../recoil/modalClientsFilter';
import { isRightSideModalOpenState } from '../recoil/modalContainer';
import { isWhiteModalContainerOpenState } from '../recoil/modalContainerWhite';
import { isDropoffsFilterModalOpenAtom } from '../recoil/modalDropoffsFilter';
import { isEditReceiptModalOpenAtom } from '../recoil/modalEditReceipt';
import { isEditRouteFilterModalOpenAtom } from '../recoil/modalEditRouteFilter';
import { isGreaseTrapFilterModalOpenAtom } from '../recoil/modalGreaseTrapFilter';
import { isInvoicesFilterModalOpenAtom } from '../recoil/modalInvoicesFilter';
import { isNewCashDisbursedModalOpenAtom } from '../recoil/modalNewCashDisbursed';
import { isNewClientModalOpenAtom } from '../recoil/modalNewClient';
import { isNewDropoffModalOpenAtom } from '../recoil/modalNewDropoff';
import { isNewEquipmentModalOpenAtom } from '../recoil/modalNewEquipment';
import { isNewGreaseTrapModalOpenAtom } from '../recoil/modalNewGreaseTrap';
import { isNewIncidentModalOpenAtom } from '../recoil/modalNewIncident';
import { ismodalNewLocationOpenAtom } from '../recoil/modalNewLocation';
import { isNewPersonModalOpenAtom } from '../recoil/modalNewPerson';
import { isNewReceiptModalOpenAtom } from '../recoil/modalNewReceipt';
import { isNewRouteModalOpenAtom } from '../recoil/modalNewRoute';
import { isNewServiceModalOpenAtom } from '../recoil/modalNewService';
import { isNewTruckModalOpenAtom } from '../recoil/modalNewTruck';
import { isNewVendorModalOpenAtom } from '../recoil/modalNewVendor';
import { isNewVendorDriverModalOpenAtom } from '../recoil/modalNewVendorDriver';
import { isNewVendorLoanModalOpenAtom } from '../recoil/modalNewVendorLoan';
import { isNewVendorTruckModalOpenAtom } from '../recoil/modalNewVendorTruck';
import { isNewWithDrawModalOpenAtom } from '../recoil/modalNewWithDraw';
import { isNewWorkerModalOpenAtom } from '../recoil/modalNewWorker';
import { isPaymentFilterModalOpenAtom } from '../recoil/modalPaymentFilter';
import { isRoutesFilterModalOpenAtom } from '../recoil/modalRoutesFilter';
import { isTruckDriversModalOpenAtom } from '../recoil/modalTruckDrivers';
import { isTruckServiceModalOpenAtom } from '../recoil/modalTruckService';
import { isTrucksFilterModalOpenAtom } from '../recoil/modalTrucksFilter';
import { isVendorDocumentsFilterModalOpenAtom } from '../recoil/modalVendorDocuments';
import { isVendorsFilterModalOpenAtom } from '../recoil/modalVendorsFilter';
import { isWorkersFilterModalOpenAtom } from '../recoil/modalWorkersFilter';

export const useModal = () => {
  // ==== States ====

  const [isWhiteModalContainerOpen, setIsWhiteModalContainerOpen] =
    useRecoilState(isWhiteModalContainerOpenState);

  const [isRightSideModalOpen, setIsRightSideModalOpen] = useRecoilState(
    isRightSideModalOpenState,
  );

  const [isNewClientModalOpen, setIsNewClientModalStateOpen] = useRecoilState(
    isNewClientModalOpenAtom,
  );

  const [isNewVendorModalOpen, setIsNewVendorModalStateOpen] = useRecoilState(
    isNewVendorModalOpenAtom,
  );

  const [isNewEquipmentModalOpen, setIsNewEquipmentModalOpen] = useRecoilState(
    isNewEquipmentModalOpenAtom,
  );

  const [isNewLocationModalOpen, setIsNewLocationModalOpen] = useRecoilState(
    ismodalNewLocationOpenAtom,
  );

  const [
    isModalFilterVendorDocumentsOpen,
    setIsModalFilterVendorDocumentsOpen,
  ] = useRecoilState(isVendorDocumentsFilterModalOpenAtom);

  const [isDropoffsFilterModalOpen, setIsDropoffsFilterModalOpen] =
    useRecoilState(isDropoffsFilterModalOpenAtom);

  const [isGreaseTrapFilterModalOpen, setIsGreaseTrapFilterModalOpen] =
    useRecoilState(isGreaseTrapFilterModalOpenAtom);

  const [isNewDropoffModalOpen, setIsNewDropoffModalOpen] = useRecoilState(
    isNewDropoffModalOpenAtom,
  );

  const [isNewGreaseTrapModalOpen, setIsNewGreaseTrapModalOpen] =
    useRecoilState(isNewGreaseTrapModalOpenAtom);

  const [isClientsFilterModalOpen, setIsClientsFilterModalOpen] =
    useRecoilState(isClientsFilterModalOpenAtom);

  const [isVendorsFilterModalOpen, setIsVendorsFilterModalOpen] =
    useRecoilState(isVendorsFilterModalOpenAtom);

  const [isNewPersonModalOpen, setIsNewPersonModalOpen] = useRecoilState(
    isNewPersonModalOpenAtom,
  );

  const [isNewVendorTruckModalOpen, setIsNewVendorTruckModalOpen] =
    useRecoilState(isNewVendorTruckModalOpenAtom);

  const [isNewVendorLoanModalOpen, setIsNewVendorLoanModalOpen] =
    useRecoilState(isNewVendorLoanModalOpenAtom);

  const [isNewVendorDriverModalOpen, setIsNewVendorDriverModalOpen] =
    useRecoilState(isNewVendorDriverModalOpenAtom);

  const [isNewServiceModalOpen, setIsNewServiceModalOpen] = useRecoilState(
    isNewServiceModalOpenAtom,
  );

  const [isNewRouteModalOpen, setIsNewRouteModalStateOpen] = useRecoilState(
    isNewRouteModalOpenAtom,
  );

  const [isRoutesFilterModalOpen, setIsRoutesFilterModalOpen] = useRecoilState(
    isRoutesFilterModalOpenAtom,
  );

  const [
    isModalFilterClientDocumentsOpen,
    setIsModalFilterClientDocumentsOpen,
  ] = useRecoilState(isClientDocumentsFilterModalOpenAtom);

  const [isInvoicesFilterModalOpen, setIsInvoicesFilterModalOpen] =
    useRecoilState(isInvoicesFilterModalOpenAtom);

  const [isTrucksFilterModalOpen, setIsTrucksFilterModalOpen] = useRecoilState(
    isTrucksFilterModalOpenAtom,
  );

  const [isNewTruckModalOpen, setIsNewTruckModalOpen] = useRecoilState(
    isNewTruckModalOpenAtom,
  );

  const [isWorkersFilterModalOpen, setIsWorkersFilterModalOpen] =
    useRecoilState(isWorkersFilterModalOpenAtom);

  const [isNewWorkerModalOpen, setIsNewWorkerModalOpen] = useRecoilState(
    isNewWorkerModalOpenAtom,
  );

  const [isNewReceiptModalOpen, setIsNewReceiptModalOpen] = useRecoilState(
    isNewReceiptModalOpenAtom,
  );

  const [isEditReceiptModalOpen, setIsEditReceiptModalOpen] = useRecoilState(
    isEditReceiptModalOpenAtom,
  );

  const [isEditRouteFilterModalOpen, setIsEditRouteFilterModalOpen] =
    useRecoilState(isEditRouteFilterModalOpenAtom);

  const [isTruckServiceModalOpen, setIsTruckServiceModalOpen] = useRecoilState(
    isTruckServiceModalOpenAtom,
  );

  const [isTruckDriversModalOpen, setIsTruckDriversModalOpen] = useRecoilState(
    isTruckDriversModalOpenAtom,
  );

  const [isNewIncidentModalOpen, setIsNewIncidentModalOpen] = useRecoilState(
    isNewIncidentModalOpenAtom,
  );
  const [isNewWithDrawModalOpen, setIsNewWithDrawModalOpen] = useRecoilState(
    isNewWithDrawModalOpenAtom,
  );
  const [isNewCashDisbursedModalOpen, setIsNewCashDisbursedModalOpen] =
    useRecoilState(isNewCashDisbursedModalOpenAtom);

  const [isPaymentFilterModalOpen, setIsPaymentFilterModalOpen] =
    useRecoilState(isPaymentFilterModalOpenAtom);

  const setPersonToEdit = useSetRecoilState(personSelectedToEdit);
  const setTruckServiceToEdit = useSetRecoilState(truckServiceToEdit);
  const setTruckDriversToEdit = useSetRecoilState(truckDriversToEdit);
  const setIncidentToEdit = useSetRecoilState(incidentSelectedToEdit);
  const setEquipmentToEdit = useSetRecoilState(equipmentSelectedToEdit);
  const setCashDisburseId = useSetRecoilState(cashDisbursedID);
  const setLocationToEdit = useSetRecoilState(locationSelectedToEdit);

  // ===== Functions  =====

  const openWhiteModalWithDelay = () => {
    setTimeout(() => {
      setIsWhiteModalContainerOpen(true);
    }, 50);
  };

  const handleOpenNewPersonModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewPersonModalOpen) {
      setIsNewPersonModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewVendorDriverModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewVendorDriverModalOpen) {
      setIsNewVendorDriverModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewVendorTruckModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewVendorTruckModalOpen) {
      setIsNewVendorTruckModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewVendorLoanModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewVendorLoanModalOpen) {
      setIsNewVendorLoanModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewServiceModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewServiceModalOpen) {
      setIsNewServiceModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewClientModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewClientModalOpen) {
      setIsNewClientModalStateOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewVendorModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewVendorModalOpen) {
      setIsNewVendorModalStateOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewEquipmentModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewEquipmentModalOpen) {
      setIsNewEquipmentModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewLocationModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewLocationModalOpen) {
      setIsNewLocationModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenClientsFilterModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isClientsFilterModalOpen) {
      setIsClientsFilterModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenDropoffsFilterModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isDropoffsFilterModalOpen) {
      setIsDropoffsFilterModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenGreaseTrapFilterModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isGreaseTrapFilterModalOpen) {
      setIsGreaseTrapFilterModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewDropoffModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewDropoffModalOpen) {
      setIsNewDropoffModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewGreaseTrapModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewGreaseTrapModalOpen) {
      setIsNewGreaseTrapModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenVendorsFilterModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isVendorsFilterModalOpen) {
      setIsVendorsFilterModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenRoutesFilterModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isRoutesFilterModalOpen) {
      setIsRoutesFilterModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewRouteModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewClientModalOpen) {
      setIsNewRouteModalStateOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenClientDocumentsModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isModalFilterClientDocumentsOpen) {
      setIsModalFilterClientDocumentsOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenVendorDocumentsModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isModalFilterVendorDocumentsOpen) {
      setIsModalFilterVendorDocumentsOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenInvoicesFilterModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isInvoicesFilterModalOpen) {
      setIsInvoicesFilterModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenPaymentFilterModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isInvoicesFilterModalOpen) {
      setIsPaymentFilterModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenTrucksFilterModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isTrucksFilterModalOpen) {
      setIsTrucksFilterModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewTruckModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewTruckModalOpen) {
      setIsNewTruckModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenWorkersFilterModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isWorkersFilterModalOpen) {
      setIsWorkersFilterModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewWorkerModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewWorkerModalOpen) {
      setIsNewWorkerModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewReceiptModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (isEditReceiptModalOpen) {
      setIsEditReceiptModalOpen(false);
    }
    if (!isNewReceiptModalOpen) {
      setIsNewReceiptModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenEditReceiptModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (isNewReceiptModalOpen) {
      setIsNewReceiptModalOpen(false);
    }
    if (!isEditReceiptModalOpen) {
      setIsEditReceiptModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenEditRouteModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isEditRouteFilterModalOpen) {
      setIsEditRouteFilterModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenTruckServiceModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isTruckServiceModalOpen) {
      setIsTruckServiceModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenTruckDriversModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isTruckDriversModalOpen) {
      setIsTruckDriversModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewIncidentModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewIncidentModalOpen) {
      setIsNewIncidentModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewWithDrawModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewIncidentModalOpen) {
      setIsNewWithDrawModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleOpenNewCashDisbursedModal = () => {
    if (!isRightSideModalOpen) {
      setIsRightSideModalOpen(true);
    }
    if (!isNewIncidentModalOpen) {
      setIsNewCashDisbursedModalOpen(true);
    }

    openWhiteModalWithDelay();
  };

  const handleCloseAllModals = () => {
    // Close white container first
    setIsWhiteModalContainerOpen(false);

    // Close dark modal area with delay
    setTimeout(() => {
      // Close all content modals. Important to add here all created modals

      if (isNewClientModalOpen) {
        setIsNewClientModalStateOpen(false);
      }
      if (isClientsFilterModalOpen) {
        setIsClientsFilterModalOpen(false);
      }
      if (isDropoffsFilterModalOpen) {
        setIsDropoffsFilterModalOpen(false);
      }
      if (isGreaseTrapFilterModalOpen) {
        setIsGreaseTrapFilterModalOpen(false);
      }
      if (isNewPersonModalOpen) {
        setIsNewPersonModalOpen(false);
      }
      if (isNewServiceModalOpen) {
        setIsNewServiceModalOpen(false);
      }
      // routes
      if (isNewRouteModalOpen) {
        setIsNewRouteModalStateOpen(false);
      }
      if (isRoutesFilterModalOpen) {
        setIsRoutesFilterModalOpen(false);
      }
      if (isModalFilterClientDocumentsOpen) {
        setIsModalFilterClientDocumentsOpen(false);
      }
      if (isInvoicesFilterModalOpen) {
        setIsInvoicesFilterModalOpen(false);
      }
      if (isTrucksFilterModalOpen) {
        setIsTrucksFilterModalOpen(false);
      }
      if (isNewTruckModalOpen) {
        setIsNewTruckModalOpen(false);
      }
      if (isWorkersFilterModalOpen) {
        setIsWorkersFilterModalOpen(false);
      }
      if (isNewWorkerModalOpen) {
        setIsNewWorkerModalOpen(false);
      }
      if (isNewReceiptModalOpen) {
        setIsNewReceiptModalOpen(false);
      }
      if (isEditReceiptModalOpen) {
        setIsEditReceiptModalOpen(false);
      }
      if (isEditRouteFilterModalOpen) {
        setIsEditRouteFilterModalOpen(false);
      }
      if (isTruckServiceModalOpen) {
        setIsTruckServiceModalOpen(false);
      }
      if (isTruckDriversModalOpen) {
        setIsTruckDriversModalOpen(false);
      }
      if (isNewIncidentModalOpen) {
        setIsNewIncidentModalOpen(false);
      }
      if (isNewEquipmentModalOpen) {
        setIsNewEquipmentModalOpen(false);
      }
      if (isNewWithDrawModalOpen) {
        setIsNewWithDrawModalOpen(false);
      }
      if (isNewCashDisbursedModalOpen) {
        setIsNewCashDisbursedModalOpen(false);
      }
      if (isPaymentFilterModalOpen) {
        setIsPaymentFilterModalOpen(false);
      }
      if (isNewLocationModalOpen) {
        setIsNewLocationModalOpen(false);
      }
      if (isNewVendorModalOpen) {
        setIsNewVendorModalStateOpen(false);
      }
      if (isVendorsFilterModalOpen) {
        setIsVendorsFilterModalOpen(false);
      }
      if (isNewVendorDriverModalOpen) {
        setIsNewVendorDriverModalOpen(false);
      }
      if (isNewVendorTruckModalOpen) {
        setIsNewVendorTruckModalOpen(false);
      }
      if (isModalFilterVendorDocumentsOpen) {
        setIsModalFilterVendorDocumentsOpen(false);
      }
      if (isNewVendorLoanModalOpen) {
        setIsNewVendorLoanModalOpen(false);
      }
      if (isNewDropoffModalOpen) {
        setIsNewDropoffModalOpen(false);
      }
      if (isNewGreaseTrapModalOpen) {
        setIsNewGreaseTrapModalOpen(false);
      }
      // Empty stored data to edit
      setPersonToEdit(null);
      setLocationToEdit(null);
      setTruckServiceToEdit(null);
      setTruckDriversToEdit(null);
      setIncidentToEdit(null);
      setEquipmentToEdit(null);

      setCashDisburseId(null);

      setIsRightSideModalOpen(false);
    }, 400);
  };

  return {
    handleOpenNewWorkerModal,
    handleOpenWorkersFilterModal,
    handleOpenNewTruckModal,
    handleOpenTrucksFilterModal,
    handleOpenInvoicesFilterModal,
    handleOpenClientDocumentsModal,
    handleOpenNewClientModal,
    handleOpenClientsFilterModal,
    handleOpenNewPersonModal,
    handleOpenNewServiceModal,
    handleCloseAllModals,
    handleOpenRoutesFilterModal,
    handleOpenNewRouteModal,
    handleOpenNewReceiptModal,
    handleOpenDropoffsFilterModal,
    handleOpenGreaseTrapFilterModal,
    handleOpenEditReceiptModal,
    handleOpenPaymentFilterModal,
    isWhiteModalContainerOpen,
    handleOpenEditRouteModal,
    handleOpenTruckServiceModal,
    handleOpenTruckDriversModal,
    handleOpenNewIncidentModal,
    handleOpenNewEquipmentModal,
    handleOpenNewWithDrawModal,
    handleOpenNewCashDisbursedModal,
    handleOpenNewLocationModal,
    handleOpenVendorsFilterModal,
    handleOpenNewVendorModal,
    handleOpenNewVendorDriverModal,
    handleOpenNewVendorTruckModal,
    handleOpenVendorDocumentsModal,
    handleOpenNewVendorLoanModal,
    handleOpenNewDropoffModal,
    handleOpenNewGreaseTrapModal,
  };
};
